import React from "react";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import { useState } from "react";
import { Grid, PageWrapper } from "components/Containers";
import Card from "components/Card";
import PageTitle from "components/PageTitle";
import { PartnersList, PartnerAddButton } from "components/Partners";

/**
 * Partners Page
 */
const Partners = () => {
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState({});
  const intl = useIntl();

  const handleEdit = (rowData) => {
    setData(rowData);
    setShowModal(true);
  };

  // Needs to use React router so we can remove <App /> container
  return (
    <PageWrapper>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Partners.Title" })}</title>
      </Helmet>
      <Grid>
        <Grid.col start={1} end={13}>
          <PageTitle
            title={<FormattedMessage id={`Partners.H1`} />}
            actionBar={<PartnerAddButton data={data} showModal={showModal} onHideModal={() => setShowModal(false)} />}
          />
        </Grid.col>
        <Grid.col start={1} end={13}>
          <Card>
            <PartnersList onClick={handleEdit} />
          </Card>
        </Grid.col>
      </Grid>
    </PageWrapper>
  );
};

export default Partners;
